import React from 'react'
import { StyleSheet, View } from 'react-native'

import Loading from '@/components/Mini/Loading'

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import { PocketPickHeader as Header } from '@/components/Mini/Header'
import { PocketPickBackground as Background } from '@/components/Mini/Background'
import { PocketPickLeaderboardCard as LeaderboardCard } from '@/components/Mini/LeaderboardCard'

export function PocketPickLeaderboardScreen() {
  const { status } = pocketPick.usePocketPickQueryStatus()
  const { leaderboard } = pocketPick.usePocketPickQueryLeaderboard()
  const handleClose = pocketPick.useHandleClose()
  const theme = pocketPick.useStore((s) => s.theme)

  const loading = leaderboard && status ? false : true
  //const loading = true;

  return (
    <Background>
      <Header title="Today's Leaderboard" handler={handleClose} />

      {loading && <Loading color={theme.accent} />}

      {!loading && (
        <View style={styles.content}>
          <LeaderboardCard />
        </View>
      )}
    </Background>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
    paddingBottom: 24
  },
  content: {
    flex: 1,
    paddingHorizontal: 16
  }
})
